import { botApi } from './botApi'
import { IStringIndexedObject, makeQueryParamString } from '../../utils/utils'
import { Action } from '../calcBot/types'
import { IActionsInfo } from './types'
import Cookies from 'universal-cookie'

export interface IActionsRequestQuery extends IStringIndexedObject<number | string | boolean | undefined> {
  startTime: number
  endTime: number
  page: number
  firstEx?: string
  secondEx?: string
  market?: string
  secondMarket?: string
  timeIndex: number
  last24h: boolean | string
  showAll: boolean | string
  lastHour: boolean | string
  isFailedOnly: boolean | string
  logicType?: string
}
const cookies = new Cookies()
export const actionsApi = botApi.injectEndpoints({
  endpoints: ({ query }) => ({
    getActions: query<{ actions: Action[]; fields: IActionsInfo }, IActionsRequestQuery>({
      query: (actions: IActionsRequestQuery) => ({
        url: `/actions?${makeQueryParamString(actions)}`,
        method: 'GET',
      }),
      transformErrorResponse: res => {
        if (res.status === 401) {
          cookies.remove('TOKEN')
        }
      },
    }),
    lastProfit: query<{ lastProfit?: number; timestamp?: number }, any>({
      query: (actions: IActionsRequestQuery) => ({
        url: `/actions/lastProfit`,
        method: 'GET',
      }),
      transformErrorResponse: res => {
        if (res.status === 401) {
          cookies.remove('TOKEN')
        }
      },
    }),
  }),
})

export const { useGetActionsQuery, useLastProfitQuery } = actionsApi
